import React from 'react';
import Box from "@mui/material/Box";
import Cropper from "react-easy-crop";
import {useMediaQuery} from "@mui/material";

const CropperComponent = ({imageSrc, crop, setCrop, zoom, setZoom, rotation, setRotation, onCropComplete}) => {
    const matches = useMediaQuery('(min-width:200px) and (max-width:600px)');

    return (
        <Box width={"100%"} height={"100%"} position={"relative"} mb={{xs: 1, sm: 3}}>
            <Cropper
                style={{
                    containerStyle: {
                        borderRadius: 12,
                        width: matches ? "100%" : "94%",
                        height: "100%",
                        margin: "0 auto"
                    }
                }}
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                minZoom={0.4}
                rotation={rotation}
                aspect={16 / 9}
                restrictPosition={false}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
                onRotationChange={setRotation}
            />
        </Box>
    );
};

export default CropperComponent;